import { render } from "./App.vue?vue&type=template&id=a7108304"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a7108304&lang=css"

import exportComponent from "C:\\Users\\noahe\\OneDrive\\Documentos\\Udemy - Vue\\Vue\\04-pokemon-game\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__